import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MmuTrackEventDirective } from './mmu-track-event.directive';
import { MmuTrackMainMenuDirective } from './mmu-track-mainMenu.directive';

@NgModule({
  declarations: [MmuTrackEventDirective, MmuTrackMainMenuDirective],
  imports: [CommonModule],
  exports: [MmuTrackEventDirective, MmuTrackMainMenuDirective]
})
export class MmuAnalyticsModule {
}
